import { Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import { selectIsDarkMode } from "../../../../redux/features/theme/theme-slice";
import IPageInfo from "../../interfaces/page-info";
import AppMenuContent from "../../ui-elements/app-menu-content/app-menu-content";
import styles from "./side-bar.module.scss";

interface IProps {
  collapsed: boolean;
  routes: IPageInfo[];
  logos: string[];
}

const SideBar = (props: IProps) => {
  const isDarkMode = useSelector(selectIsDarkMode);

  return (
    <Container
      className={`${styles["side-bar"]} h-100 w-100 m-0 ${
        isDarkMode ? styles.boxShadowDark : styles.boxShadowLight
      }`}
    >
      <AppMenuContent {...props} />
    </Container>
  );
};

export default SideBar;
